import React from "react";
import { IconButton as MuiIconButton, makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  root: {
    "& > *": {
      margin: theme.spacing(1),
    },
  },
}));

export default function IconDownloadButton(props) {
  const { children, imageUrl, fileName, ...other } = props;
  const classes = useStyles();

  const DownloadBlobButton = async () => {
    try {
      const response = await fetch(imageUrl);

      if (!response.ok) throw new Error("Network response was not ok.");

      const blob = await response.blob();
      const blobUrl = URL.createObjectURL(blob);
      const link = document.createElement("a");

      link.href = blobUrl;
      link.setAttribute("download", fileName);
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);
      URL.revokeObjectURL(blobUrl);
    } catch (error) {
      console.error("Failed to download", error);
    }
  };

  return (
    <MuiIconButton
      component="span"
      className={`${classes.root}`}
      onClick={DownloadBlobButton}
      {...other}
    >
      {children}
    </MuiIconButton>
  );
}
